/**
 * eBoutique API
 * eBoutique API
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export class RSSRemitEntityValue {
  fnmLnNo?: string;
  fnmSsnNo?: number;
  lstUpdDt?: string;
  lstUpdUsrId?: string;
  recCrenDt?: string;
  recCrtrUsrId?: string;
  rmttAmt?: number;
  rmttAmtCent?: number;
  rmttAmtSign?: string;
  rssSntToFlag?: string;
  rmttTypCd?: string;
  rssRmttCd?: string;
  prdctTypCd?: string;
  rssRmttDt?: string;
  rmttPurpsTypCd?: number;
}
